"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInteractionGumballParameterSettings = void 0;
// #endregion Interfaces (1)
// #region Functions (1)
function isInteractionGumballParameterSettings(def) {
    return (def === null || def === void 0 ? void 0 : def.type) === 'gumball';
}
exports.isInteractionGumballParameterSettings = isInteractionGumballParameterSettings;
// #endregion Functions (1)
//# sourceMappingURL=IGumballParameterSettings.js.map